import React from 'react';

export const Loading = () => {
  // inline loading
  return (
    <div className='loadingio-spinner-spinner-ack7w0lzpog'>
      <div className='ldio-l3zniwkww9q'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
